import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../storage-service/storage.service';
import { Router } from '@angular/router';
import { DialogService } from '../confirm-dialog/dialog.service';
import { AuthenticationService } from '../authentication-service/authentication.service';
import { switchMap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private storage: StorageService,
    private _router: Router,
    private _dialogService: DialogService,
    private _authService: AuthenticationService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.storage.get('id_token');
    if (req.url.includes('/login') || req.url.includes('/refresh-token')) {
      return next.handle(req);
    }
    this._authService.initializeWindowIfTokenExists();
    this._authService.onApiCall();
    if (token && this._authService.shouldRefreshOnApiCall()) {
      return this._authService.refreshAuthToken().pipe(
        switchMap(() => {
          const refreshedToken = this.storage.get('id_token');
          const cloned = req.clone({
            setHeaders: {
              Authorization: `Bearer ${refreshedToken}`
            }
          });
          return next.handle(cloned);
        }),
        catchError(err => {
          //this._authService.logout();
          return throwError(err);
        })
      );
    }
    if (token) {
      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(cloned);
    } else {
      return next.handle(req);
    }
  }
}
